import React, { useCallback, useContext, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import styled from 'styled-components'

import { Links, Buttons } from '../../styled'
import { colors } from 'helpers/colors'
import svgIcons from 'helpers/svgIcons'
import OutlinedButton from '../outlined_button'
import HeaderButton from '../header_button/header_button_old'
import HamburgerButton from '../hamburger_button'
import Flex from 'components/reusable/flex'
import { routes } from 'helpers/router_helper'
import ScAnalytics from 'classes/sc_analytics'
import { sections } from 'components/views/logged_out/landing_page/sections'
import { ModalContext } from 'contexts/contexts'
import { modalEnum } from 'components/modals/v2/modal'
import useNavigateSignUp from 'hooks/navigation/use_navigate_sign_up'

const MobileButtonsContainer = styled(Flex)`
  @media (min-width: 769px) {
    display: none;
  }
`

const LoggedOutHeaderRightItems = ({ pressTab, isMenuOpen, onOpen }) => {
  const modalContext = useContext(ModalContext)
  const location = useLocation()
  const history = useHistory()
  const handleNavigateSignUp = useNavigateSignUp()
  const onSignIn = useCallback(() => modalContext.onOpenModal(modalEnum.signIn), [])

  const alternativeStyle = useMemo(() => {
    return location.pathname.search('/position') === -1
  }, [location.pathname])

  const onCreateProject = useCallback(() => {
    const page = window.location.pathname
    ScAnalytics.sendProjectInitFunnel(false, sections.header, page, true)
    history.push(routes.createProject.redirectUrl())
  }, [history])

  return (
    <>
      <Links>
        <HeaderButton
          action={() => pressTab('faq')}
          path={routes.faq.redirectUrl()}
          label="How it works"
          icon={() => svgIcons.headerFaq(colors.gray[600])}
        />
        <HeaderButton action={onSignIn} label="Log In" icon={() => svgIcons.headerLogin(colors.gray[600])} />
        <HeaderButton
          action={() => pressTab('contact')}
          path="/contact"
          label="Contact Us"
          icon={() => svgIcons.headerContact(colors.gray[600])}
        />

        <Buttons>
          <OutlinedButton
            onClick={() => handleNavigateSignUp('Sign Up', 'Header Right Links', 'Header')}
            children="Sign Up"
            color={alternativeStyle ? colors.primary[500] : colors.gray[700]}
            width={136}
          />
          <OutlinedButton
            children="Post a Job"
            color={alternativeStyle ? colors.gray[700] : colors.primary[500]}
            width={136}
            onClick={onCreateProject}
          />
        </Buttons>
      </Links>

      <MobileButtonsContainer>
        <HamburgerButton active={isMenuOpen} setActive={onOpen} />
      </MobileButtonsContainer>
    </>
  )
}

export default LoggedOutHeaderRightItems
